import { render, staticRenderFns } from "./CandidatesActionList.vue?vue&type=template&id=2b40f830&"
import script from "./CandidatesActionList.vue?vue&type=script&lang=js&"
export * from "./CandidatesActionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports